import styled from 'styled-components';

interface IStyContainer {
  readonly filterBlur: string;
  readonly top: string;
}

export const StyContainer = styled.div<IStyContainer>`
  position: absolute;
  top: ${({ top }) => top};
  left: 50%;
  transform: translate(-50%, -50%);
  filter: ${({ filterBlur }) => `blur(${filterBlur})`};
  opacity: 0.8;
`;

interface IStyCircularGlow {
  readonly colorStart: string;
  readonly colorEnd: string;
  readonly filterBlur: string;
  readonly width: string;
  readonly height: string;
  readonly opacity: number;
  readonly animationBreathingTime: string;
}

export const StyCircularGlow = styled.div<IStyCircularGlow>`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  border-radius: 50%;
  background-color: rgba(21, 24, 35, 0.9);
  box-shadow: inset 2px 2px 10px rgba(0, 0, 0, 0.3);
  animation: breathing ${({ animationBreathingTime }) => animationBreathingTime}
    ease-in-out infinite;
  position: relative;
  z-index: 0;
  pointer-events: none;
  transition: 200ms;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    filter: ${({ filterBlur }) => `blur(${filterBlur})`};
    transform: scale(1);
    background: ${({ colorStart, colorEnd }) =>
      `linear-gradient(90deg, ${colorStart}, ${colorEnd})`};
    background-size: 200% 200%;
    animation: animateGlow 12s ease-in-out infinite;
    opacity: ${({ opacity }) => opacity};
    border-radius: 50%;
    pointer-events: none;
    z-index: -1;
  }

  @keyframes animateGlow {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }

  @keyframes breathing {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.4);
    }
    100% {
      transform: scale(1);
    }
  }
`;
